import * as React from 'react';
import PropTypes from 'prop-types';

function IconClose(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : 16}
      height={props.height ? props.height : 16}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={props.color ? props.color : '#000'}
        d="M13.387 13.07c0 .086-.07.157-.157.157l-1.289-.006L10 10.906 8.06 13.22l-1.29.006a.155.155 0 01-.157-.157c0-.037.014-.072.037-.101l2.541-3.028-2.54-3.025a.157.157 0 01.12-.258l1.29.006L10 8.977l1.94-2.313 1.289-.006c.085 0 .156.069.156.156a.162.162 0 01-.037.102L10.81 9.941l2.542 3.028a.157.157 0 01.035.101z"
      ></path>
      <path
        fill={props.color ? props.color : '#000'}
        d="M10 18.73a8.75 8.75 0 11.001-17.5A8.75 8.75 0 0110 18.73zm0-16.015a7.267 7.267 0 000 14.531 7.267 7.267 0 000-14.531z"
      ></path>
    </svg>
  );
}

IconClose.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

export default IconClose;
